import { Accordion, AccordionDetails, AccordionSummary, Box, Stack, SxProps } from '@mui/material';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import React, { PropsWithChildren } from 'react';

import { themeColors } from '@/config/theme/themeColors.ts';

interface Props extends PropsWithChildren {
  EndComponent?: React.ReactNode;
  expanded?: boolean;
  sx?: SxProps;
  title?: string;
}

export const CustomerDetailsAccordion: React.FC<Props> = props => {
  const { children, EndComponent, expanded, sx, title } = props;

  return (
    <Box sx={sx}>
      <Accordion
        expanded={expanded ?? undefined}
        sx={{
          '&.MuiAccordion-root:last-of-type': { borderRadius: 0 },
          '&.MuiAccordionSummary-content': { '&.Mui-expanded': { mb: 0 } },
          height: '100%',
        }}
      >
        {title && (
          <AccordionSummary component="div">
            <Stack sx={{ width: '100%' }}>
              <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography sx={{ color: themeColors.greyDark }} variant="f16Medium">
                  {title}
                </Typography>
                {EndComponent}
              </Stack>
              <Divider orientation="horizontal" />
            </Stack>
          </AccordionSummary>
        )}
        <AccordionDetails sx={{ pt: !title ? 2 : 0 }}>{children}</AccordionDetails>
      </Accordion>
    </Box>
  );
};
